import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import FancyHoverImg from 'core/components/FancyHoverImg';
import Button from 'core/ui/Button';
import { promiser, trackEvent } from 'core/utils';
import CartContext from 'core/providers/CartContext';

import {
	renderPrice as currency,
} from 'core/utils';

import {
	Upsell,
	Name,
	Price,
	CurrencyCode,
} from './upsellStyles';
import { checkIfProductInstanceIsInCart } from 'cart/utils';

const SingleUpsell = ({
	image, name, instances,
	currencySymbol,
	currencyCode,
}) => {
	// Grab the first instance for now...
	const { addProductToCart, carts, removeFromCart } = useContext(CartContext);
	const instance = instances[0];
	const [addingToCart, setAddingToCart] = useState(false);
	const [addError, setCartError] = useState(false);
	const [addedToCart, setAddedToCart] = useState(false);

	useEffect(() => {
		const existingCartProduct = checkIfProductInstanceIsInCart({ productInstanceId: instance.id, carts: carts });
		if (existingCartProduct) setAddedToCart(existingCartProduct);
	}, [carts, instance.id]);

	const startActions = () => {
		setAddingToCart(true);
		setCartError(false);
	};

	const finishActions = () => {
		setAddingToCart(false);
		setCartError(false);
	};

	const handleErr = error => {
		console.log(error);
		trackEvent('UpsellError', {
			heap: [],
			statjoy: [],
			fullstory: [],
		});
		return setCartError(true);
	};

	const addToCart = productInstanceId => async () => {
		if (addedToCart) return;
		startActions();
		const [error, cart] = await promiser(addProductToCart({ productInstanceId, quantity: 1, subscriptionTypeTermId: null }));
		if (error) return handleErr(error);
		const cartProduct = checkIfProductInstanceIsInCart({ productInstanceId: productInstanceId, carts: [cart] });
		setAddedToCart(cartProduct);

		trackEvent('UpsellAddedToCart', {
			heap: [],
			statjoy: [],
			fullstory: [],
		});
		finishActions();
	};

	const removeItem = cartProductId => async () => {
		startActions();
		const [error, _] = await promiser(removeFromCart(cartProductId));
		if (error) return handleErr(error);
		setAddedToCart(false);
		finishActions();
	};

	let ctaText = `Add to Order`;
	if (addingToCart) ctaText = `Processing...`;
	if (addError) ctaText = `Error adding...`;
	if (addedToCart) ctaText = `Added!`;
	return (
		<Upsell>
			{image && (<FancyHoverImg src={image} alt={name} title={name} width="180" height="144" $contain />)}
			<Name title={name}>{name}</Name>
			<Price>
				{currency(instance.instancePrice, currencySymbol)}
				{currencyCode !== 'USD' && <CurrencyCode> {currencyCode}</CurrencyCode>}
			</Price>
			<Button
				className="upsell-main-cta"
				themeType={addedToCart ? "positive" : "antistroke"}
				onClick={addedToCart ? removeItem(addedToCart.id) : addToCart(instance.id)}
				disabled={addingToCart}
			>{ ctaText }</Button>
		</Upsell>
	);
};

SingleUpsell.propTypes = {
	image: PropTypes.string,
	name: PropTypes.string,
	instances: PropTypes.array,
	currencySymbol: PropTypes.string,
	currencyCode: PropTypes.string,
};

SingleUpsell.defaultProps = {};

export default SingleUpsell;
